import type { EventName } from "@lit/react";
import { PasswordField as PasswordFieldElement, type PasswordFieldEventMap as _PasswordFieldEventMap, } from "@vaadin/password-field/vaadin-password-field.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { PasswordFieldElement, };
export type PasswordFieldEventMap = Readonly<{
    onChange: EventName<_PasswordFieldEventMap["change"]>;
    onInput: EventName<_PasswordFieldEventMap["input"]>;
    onInvalidChanged: EventName<_PasswordFieldEventMap["invalid-changed"]>;
    onValidated: EventName<_PasswordFieldEventMap["validated"]>;
    onValueChanged: EventName<_PasswordFieldEventMap["value-changed"]>;
}>;
const events = { onChange: "change", onInput: "input", onInvalidChanged: "invalid-changed", onValidated: "validated", onValueChanged: "value-changed" } as PasswordFieldEventMap;
export type PasswordFieldProps = WebComponentProps<PasswordFieldElement, PasswordFieldEventMap>;
export const PasswordField = createComponent({
    elementClass: PasswordFieldElement, events, react: React, tagName: "vaadin-password-field"
});
